import { Box, Flex } from 'mds-web-ui'
import React from 'react'

export const WhatsNewWrapper = props => (
  <Flex justifyContent="center">
    <Box
      as="main"
      pt={[4, 5]}
      px={[3, 3, 4, 5]}
      pb={[4, 5]}
      css={{
        maxWidth: '900px'
      }}
      {...props}
    />
  </Flex>
)
